export const studyId = state => state.studyId;
export const completion = state => state.completion;
export const completionParticipant = state => state.completionParticipant;
export const siteListInParticipants = state => state.siteListInParticipants;
export const eConsentRawData = state => state.eConsentRawData;
export const eConsentDispositionData = state => state.eConsentDispositionData;
export const consentBlocks = state => state.consentBlocks;

export const complianceWidgets = state => state.complianceWidgets;
export const specificSiteId = state => state.specificSiteId;
export const dataLoaded = state => state.dataLoaded;
export const visConsentDisposition = state => state.visConsentDisposition;

export const filterTriggered = state => state.filterTriggered;
export const countrySelected = state => state.countrySelected;

export const countryList = state => state.countryList;
export const allSitesList = state => state.allSitesList;
export const participantRaws = state => state.participantRaws;
export const participantList = state => state.participantList;
export const sitesSelected = state => state.sitesSelected;
export const participantsSelected = state => state.participantsSelected;

export const dashboardLastUpdated = state => state.dashboardLastUpdated;